// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomCalendarHead_root___OidK","label":"CustomCalendarHead_label__4b4Xz","controls":"CustomCalendarHead_controls___o4v1"};